import { Injectable } from '@angular/core';
import {MatPaginatorIntl} from "@angular/material/paginator";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class MatPaginatorService extends MatPaginatorIntl{

    constructor(private translate: TranslateService) {
     super();
     this.translate.onLangChange.subscribe(() => {
         this.getAndInitTranslations();
    });

    this.getAndInitTranslations();
  }

    getAndInitTranslations() {
    this.itemsPerPageLabel = this.translate.instant('paginator.itemsPerPageLabel');
    this.nextPageLabel = this.translate.instant('paginator.nextPageLabel');
    this.previousPageLabel = this.translate.instant('paginator.previousPageLabel');
    this.firstPageLabel = this.translate.instant('paginator.firstPageLabel');
    this.lastPageLabel = this.translate.instant('paginator.lastPageLabel');

    this.changes.next(); // 👈 refresh labels
}
}
